import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check } from "lucide-react";
import { CONTRACT, SHORT_CA } from "@/constants/links";

export default function CopyContract({ testid, className = "", label }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT);
      setCopied(true);
      toast("CA copied. The hood stays on.");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast("Copy failed. Paws too big. Select it manually.");
    }
  };

  return (
    <button onClick={copy} data-testid={testid} className={`btn ${className}`}>
      {copied ? <Check size={14} /> : <Copy size={14} />}
      <span className="font-mono normal-case tracking-normal">{label ?? SHORT_CA}</span>
    </button>
  );
}
